module.exports = __webpack_public_path__ + "2acb60f2/img/grid-web-icon.d0395d64.svg";